// extracted by mini-css-extract-plugin
export var contactContainer = "Footer-module--contactContainer--6ce91";
export var divider = "Footer-module--divider--3f3ac";
export var emailGrid = "Footer-module--emailGrid--2e099";
export var footer = "Footer-module--footer--ed43f";
export var linksContainer = "Footer-module--linksContainer--5d480";
export var linksDivider = "Footer-module--linksDivider--d6b92";
export var navContainer = "Footer-module--navContainer--96eb1";
export var navLogo = "Footer-module--navLogo--2be5a";
export var privacyLink = "Footer-module--privacyLink--8e42a";
export var socialContainer = "Footer-module--socialContainer--b7a71";
export var socialIcon = "Footer-module--socialIcon--1fc3d";
export var subscribeGrid = "Footer-module--subscribeGrid--ac0b3";